import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  fetchAuditDrgChanges,
  fetchBottomSectionAuditDetails,
  fetchDRGInfoOfEpisode,
  fetchTopSectionEpisodeDetails,
  sendAuditDrgChanges,
  updateAuditStatus,
} from "./redux/AuditorViewSlicer";
import { toast } from "react-toastify";
import { PencilImg } from "../../web-workflow/assests/svgImages/Images";
import { Italic } from "lucide-react";
import { useLazyGetData2Query } from "../../../store/apiSlice";
import { acceptCode, validateCode } from "../../CodingScreen/Service";
import axiosInstance from "../../../axiosinterceptor";
import { head } from "lodash";
import { Dropdown } from "react-bootstrap";
import Select from "react-select";
import { IconTemperatureMinus } from "@tabler/icons-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import trash_icon from "../../../assets/TrashFill.svg";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const AuditorCodeEnhance = () => {
  const { selectedQueueworkSpace } = useSelector((state) => state.episodeList);

  const topSectionData = useSelector(
    (state) => state.auditorView.topsectiondetails.topsectionEpisodeDetails,
  );
  const bottomSectionAuditData = useSelector(
    (state) => state.auditorView.bottomsectiondetails.bottomSectionAuditDetails,
  );
  const currentDrgDetails = useSelector(
    (state) => state.auditorView.fetchDrgInfo.currentDrgDetails,
  );
  const drgAndNwau = currentDrgDetails?.map((item) => ({
    drg: item?.drg,
    nwau: item?.nwau,
    version: item.drg_version,
  }));
  const episodeDetails = JSON.parse(sessionStorage.getItem("episodeDetails"));

  const auditDrgChanges = useSelector(
    (state) => state.auditorView.drgAuditChanges.drgAuditChanges,
  );
  const [selectedAuditChanges, setSelectedAuditChanges] = useState([]);
  const [selectedACSOption, setSelectedACSOption] = useState(null);
  const [auditComment, setAuditComment] = useState(
    bottomSectionAuditData?.comment || "",
  );
  const BASE_RATE = 6465;
  const [otherComment, setOtherComment] = useState(
    auditDrgChanges?.others?.text || "",
  );
  // console.log(auditDrgChanges, currentDrgDetails, drgAndNwau, "szdxfcghn");

  const acsOptions = React.useMemo(() => {
    return (
      auditDrgChanges?.acs?.options?.map((item) => ({
        value: item.id,
        label: item.code,
      })) || []
    );
  }, [auditDrgChanges]);
  const [showAuditModal, setShowAuditModal] = useState(false);
  const [inputErrorFiled, setInputErrorField] = useState(false);
  const [inputErrors, setInputErrors] = useState({
    principal: [],
    additional: [],
    procedure: [],
  });
  const toggleAuditModal = () => setShowAuditModal(!showAuditModal);
  const [auditValues, setAuditValues] = useState({
    auditDrg: "",
    auditNwau: "",
    auditRevenue: "",
  });
  console.log(auditValues, "auditValues");
  const [
    fetchData1,
    {
      data: data1,
      isLoading: isLoading1,
      isFetching: isFetching1,
      error: error1,
    },
  ] = useLazyGetData2Query();
  const [codingState, setCodingState] = useState(null);
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;
  const codebookinternalEnv = process.env.REACT_APP_FLAG_INTERNAL;
  const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const codebooksanhcEnv = process.env.REACT_APP_FLAG_SAN_HC;
  const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
  const codebooknmhsEnv = process.env.REACT_APP_FLAG_NMHS;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const pallasaiTestCodebookEnv = process.env.REACT_APP_FLAG_PALLASAI_TEST;
  const codebookfigiEnv = process.env.REACT_APP_FLAG_FIJI_DEV;
  const currentRevenue =
    Math.round(
      currentDrgDetails?.weight *
        (codebookusaEnv ? 0.676 * 6624 * 1 + 0.324 * 6624 : 6465),
    ) || 0;

  const dispatch = useDispatch();
  const lastHcpLineId = sessionStorage.getItem("last_hcp_line_id");

  console.log(
    topSectionData,
    bottomSectionAuditData,
    currentDrgDetails?.weight,
    currentRevenue - auditValues.auditRevenue,
    "topSectionData",
  );
  const { principal_diagnosis, additional_diagnoses, procedure_codes } =
    data1?.data || {};

  const parseDiagnosisCode = (fullCode = "") => {
    const cof = fullCode.charAt(0);
    const code = fullCode.slice(1);

    return { cof, code };
  };
  const normalize = (code) => code?.trim().toUpperCase();

  const currentPrincipalCodes =
    principal_diagnosis
      ?.filter(
        (item) => typeof item?.code === "string" && item.code.trim() !== "",
      )
      .map((item) =>
        normalize(
          item.origin === "AI" ? item.code.slice(1) : item.code.slice(2),
        ),
      ) || [];

  const currentAdditionalCodes =
    additional_diagnoses?.map((item) =>
      normalize(
        item?.origin === "AI" ? item?.code.slice(1) : item.code.slice(2),
      ),
    ) || [];

  const currentProcedureCodes =
    procedure_codes?.map((item) => normalize(item?.code)) || [];

  const allCurrentCodes = new Set([
    ...currentPrincipalCodes,
    ...currentAdditionalCodes,
    ...currentProcedureCodes,
  ]);

  const buildDiagnosisCode = (originalCode, auditCof, auditCode) => {
    const { cof, code } = parseDiagnosisCode(originalCode);

    return `${auditCof || cof}${auditCode || code}`;
  };

  const allPrincipalCodes = codingState?.principal?.map((item) =>
    buildDiagnosisCode(item.code, item.auditCof, item.auditCode),
  );

  const allAdditionalCodes = codingState?.additional?.map((item) =>
    buildDiagnosisCode(item.code, item.auditCof, item.auditCode),
  );

  const allProcedureCodes = codingState?.procedure?.map(
    (item) => item.auditCode || item.code,
  );
  const getAllNewAuditCodes = () => {
    const auditPrincipal =
      codingState?.principal?.map((item) =>
        normalize(buildDiagnosisCode(item.code, item.auditCof, item.auditCode)),
      ) || [];

    const auditAdditional =
      codingState?.additional?.map((item) =>
        normalize(buildDiagnosisCode(item.code, item.auditCof, item.auditCode)),
      ) || [];

    const auditProcedure =
      codingState?.procedure?.map((item) =>
        normalize(item.auditCode || item.code),
      ) || [];

    return [...auditPrincipal, ...auditAdditional, ...auditProcedure];
  };
  // Helper to update error for a specific field
  const setFieldError = (section, index, hasError) => {
    setInputErrors((prev) => {
      const newErrors = { ...prev };
      if (!newErrors[section]) newErrors[section] = [];

      // Update the error state for this specific index
      newErrors[section][index] = hasError;

      return newErrors;
    });
  };
  const handleAuditChangeToggle = (id, checked) => {
    setSelectedAuditChanges((prev) => {
      if (checked) {
        return [...prev, id];
      } else {
        return prev.filter((item) => item !== id);
      }
    });
  };
  // Helper to check if a field has error
  const hasFieldError = (section, index) => {
    return inputErrors[section] && inputErrors[section][index] === true;
  };
  const handleRevenueChange = (value) => {
    const revenue = Number(value);

    setAuditValues((prev) => ({
      ...prev,
      auditRevenue: value,
      auditNwau: value ? (revenue / BASE_RATE).toFixed(4) : "",
    }));
  };

  const handleWeightChange = (value) => {
    const weight = Number(value);

    setAuditValues((prev) => ({
      ...prev,
      auditNwau: value,
      auditRevenue: value ? Math.round(weight * BASE_RATE) : "",
    }));
  };

  // Clear all errors
  const clearAllErrors = () => {
    setInputErrors({
      principal: [],
      additional: [],
      procedure: [],
    });
  };

  const handleEditSave = () => {
    let auditChangesPayload = [...selectedAuditChanges];

    // Add ACS option ids if selected
    if (selectedACSOption?.value) {
      auditChangesPayload.push(selectedACSOption.value);
    }

    const auditChangespayload = {
      hcp_line_id: lastHcpLineId,
      audit_changes: auditChangesPayload,
      audit_comment: auditComment,
      other_comment: otherComment,
    };
    console.log(auditChangespayload, "sdzfghjk");
    dispatch(sendAuditDrgChanges(auditChangespayload))
      .unwrap()
      .then(() => {
        setSelectedAuditChanges([]);
        setSelectedACSOption(null);
        setAuditComment("");
        setOtherComment("");
      })
      .catch((error) => {
        console.error(error);
      });
    // Collect all newly entered audit codes
    const newCodes = [
      ...(codingState?.principal?.map((item) => normalize(item.auditCode)) ||
        []),
      ...(codingState?.additional?.map((item) => normalize(item.auditCode)) ||
        []),
      ...(codingState?.procedure?.map((item) => normalize(item.auditCode)) ||
        []),
    ].filter((code) => code); // remove empty strings

    // Check for duplicates against original codes
    const hasDuplicate = newCodes.some((code) => allCurrentCodes.has(code));
    console.log(newCodes, allCurrentCodes, getAllNewAuditCodes(), "compare");

    if (hasDuplicate) {
      toast.warning("Entered code already exists!");
      return;
    }
    console.log(episodeDetails, "szdfghjkl");

    const queueId = episodeDetails?.queue?.find(
      (item) => item.queue_name === "Code Enhance",
    )?.queue_id;

    const payload = {
      hcp_line_id: lastHcpLineId,
      principal_diagnosis_code: allPrincipalCodes.join(","),
      additional_diagnoses_code: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      drg_code: auditValues.auditDrg === "" ? [] : auditValues.auditDrg,
      drg_weight: auditValues.auditNwau === "" ? [] : auditValues.auditNwau,
      // audit_revenue: auditValues.auditRevenue,
      is_confirmed: true,
      grouper_versions: [drgAndNwau[0].version],
      request_from: "AU",
      queue_type: "AUDIT",
      queue_id: queueId ?? null,
    };

    acceptCode(payload, location.pathname)
      .then(() => {
        setAuditValues({
          auditDrg: "",
          auditNwau: "",
          auditRevenue: "",
        });
        toast.success("Updated Successfully");
      })
      .catch(() => toast.error("Error occurred"))
      .finally(() => toggleAuditModal());
  };

  const normalizeCodingData = (data) => ({
    principal: (data?.principal_diagnosis?.length
      ? data.principal_diagnosis
      : [{ code: "", isNew: true }]
    ).map((item) => ({
      ...item,
      auditCode: "",
      auditCof: "",
    })),

    additional: (data?.additional_diagnoses || []).map((item) => ({
      ...item,
      auditCode: "",
      auditCof: "",
    })),

    procedure: (data?.procedure_codes || []).map((item) => ({
      ...item,
      auditCode: "",
    })),
  });
  useEffect(() => {
    if (data1?.data) {
      setCodingState(normalizeCodingData(data1.data));
    }
  }, [data1]);
  useEffect(() => {
    if (bottomSectionAuditData?.comment !== undefined) {
      setAuditComment(bottomSectionAuditData.comment);
    }
  }, [bottomSectionAuditData]);

  // Check if data exists and is not false
  const topSectionConfig = topSectionData
    ? [
        { label: "Episode ID", value: topSectionData.episode_identifier },
        {
          label: "Admission Date",
          value: topSectionData.admission_date,
        },
        {
          label: "Discharge Date",
          value: topSectionData.discharge_date,
        },
        { label: "LOS", value: topSectionData.length_of_stay },
        { label: "Speciality", value: topSectionData.speciality ?? "-" },
        { label: "Care type", value: topSectionData.care_type ?? "-" },
        { label: "DRG", value: topSectionData.drg ?? "-" },
        {
          label: "NWAU",
          value: topSectionData.current_drg_revenue ?? "-",
        },
        {
          label: "$",
          value: topSectionData.current_drg_revenue
            ? `$${topSectionData.current_drg_revenue}`
            : "-",
        },
        {
          label: "Insurer identifier",
          value: topSectionData.insurer_identifier ?? "-",
        },
      ]
    : [];
  const bottomAuditConfig = bottomSectionAuditData
    ? [
        { label: "Audit DRG", value: bottomSectionAuditData.drg ?? "-" },
        {
          label: "Audit NWAU",
          value: bottomSectionAuditData.nwau ?? "-",
        },
        {
          label: "Audit $",
          value: bottomSectionAuditData.revenue
            ? `$${bottomSectionAuditData.revenue}`
            : "-",
        },
        {
          label: "Revenue Difference",
          value:
            bottomSectionAuditData.revenue_diff !== null &&
            bottomSectionAuditData.revenue_diff !== undefined
              ? `$${bottomSectionAuditData.revenue_diff}`
              : "-",
        },
        {
          label: "Audit Changes #",
          value: bottomSectionAuditData.audit_changes ?? "-",
        },
        {
          label: "Audit Date",
          value: bottomSectionAuditData.audit_date,
        },
        {
          label: "Auditor",
          value: bottomSectionAuditData.auditor ?? "-",
        },
      ]
    : [];
  const auditFieldMap = React.useMemo(
    () => [
      { key: "principal_diagnoses", label: "Principal Diagnosis" },
      { key: "additional_diagnoses", label: "Additional Diagnoses" },
      { key: "procedure_code", label: "Procedure Codes" },
      { key: "acs", label: "ACS", type: "dropdown" },
      { key: "national_coding_advice", label: "National Coding Advice" },
      { key: "state_coding_advice", label: "State Coding Advice" },
      { key: "enhance_audit_rule", label: "Enhance Audit Rule" },
      { key: "others", label: "Other", type: "text" },
    ],
    [],
  );
  const extractCodeParts = (value) => {
    if (!value || typeof value !== "string") {
      return { dcid: null, cof: null, code: "" };
    }
    const regex = /^([A-Z]{1,2}|[08])?(1|2)?([A-Z]\d{2}(?:\.\d+)?|M\d{4}\/\d)$/;
    const match = value.match(regex);
    if (!match) return null;

    const [, dcid, cof, code] = match;

    return {
      dcid: dcid || null,
      cof: cof || null,
      code,
    };
  };
  const updateAuditField = (section, index, field, value) => {
    setCodingState((prev) => ({
      ...prev,
      [section]: prev[section].map((item, i) =>
        i === index ? { ...item, [field]: value } : item,
      ),
    }));
  };

  const handleAuditToggle = async (hcpAuditId, isAudited) => {
    try {
      const result = await dispatch(
        updateAuditStatus({
          hcp_audit_id: hcpAuditId,
          is_audited: isAudited,
        }),
      )
        .unwrap()
        .then(() => {
          toast.success("Audited status updated successfully");
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error("Failed to update audit status:", error);
      toast.error(error || "Failed to update audit status");
    }
  };

  useEffect(() => {
    dispatch(fetchTopSectionEpisodeDetails());
    dispatch(fetchBottomSectionAuditDetails());
  }, [dispatch]);
  console.log(data1, "auditdataq");
  const validateCodeAPI = async (code, type) => {
    const originalType = type;
    if (type === "additional" || type === "principal") {
      type = "ICD";
    } else {
      type =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        codebooksanprodEnv||
        pallasaiTestCodebookEnv ||
        codebooksanhcEnv
          ? "ACHI"
          : codebookusaEnv
            ? "CPT"
            : "";
    }
    const url = "/checkIfCodeExists";
    const payload = {
      u_agey: data1?.data?.meta?.age_y,
      u_aged: data1?.data?.meta?.age_d,
      sex: data1?.data?.meta?.sex,
      code: code,
      check_for: type,
      check_type: originalType === "principal" ? "PDX" : "",
    };
    try {
      const response = await axiosInstance.post(url, payload);
      if (response.status === 200) {
        return {
          valid: response.data.code_exists,
          description: response.data.description || "",
          isWarning: response.data.is_warning || false,
          warningDescription: response.data.warning_description || "",
          isPopup: response.data.should_popup,
        };
      }
    } catch (error) {
      console.error("Error validating code", error);
    }
    return {
      valid: false,
      description: "",
      isWarning: false,
      warningDescription: "",
      isPopup: "",
    };
  };
  useEffect(() => {
    if (auditDrgChanges) {
      // Top level checkboxes
      const preSelected = Object.values(auditDrgChanges)
        .filter((item) => item?.is_clicked)
        .map((item) => item?.id);

      setSelectedAuditChanges(preSelected);

      // ACS options
      const acsSelected =
        auditDrgChanges?.acs?.options
          ?.filter((opt) => opt?.is_clicked)
          ?.map((opt) => ({
            value: opt.id,
            label: opt.code,
          })) || [];

      setSelectedACSOption(acsSelected);
    }
  }, [auditDrgChanges]);

  const handleCommentSubmit = () => {
    let auditChangesPayload = [...selectedAuditChanges];

    // Add ACS option ids if selected
    if (selectedACSOption?.value) {
      auditChangesPayload.push(selectedACSOption.value);
    }

    const auditChangespayload = {
      hcp_line_id: lastHcpLineId,
      audit_changes: auditChangesPayload,
      audit_comment: auditComment,
      other_comment: otherComment,
    };
    console.log(auditChangespayload, "sdzfghjk");
    dispatch(sendAuditDrgChanges(auditChangespayload))
      .unwrap()
      .then(() => {
        toast.success("Comment added successfully");
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleDelete = (section, index) => {
  setCodingState((prev) => {
    const updatedSection = prev[section].filter((_, i) => i !== index);

    const newState = {
      ...prev,
      [section]: updatedSection,
    };

    triggerAcceptCode(newState);

    return newState;
  });
};
const triggerAcceptCode = (state) => {
  const buildDiagnosisCode = (originalCode, auditCof, auditCode) => {
    const cof = originalCode?.charAt(0);
    const code = originalCode?.slice(1);
    return `${auditCof || cof}${auditCode || code}`;
  };

  const principalCodes =
    state?.principal?.map((item) =>
      buildDiagnosisCode(item.code, item.auditCof, item.auditCode)
    ) || [];

  const additionalCodes =
    state?.additional?.map((item) =>
      buildDiagnosisCode(item.code, item.auditCof, item.auditCode)
    ) || [];

  const procedureCodes =
    state?.procedure?.map((item) => item.auditCode || item.code) || [];

  const queueId = episodeDetails?.queue?.find(
    (item) => item.queue_name === "Code Enhance"
  )?.queue_id;

  const payload = {
    hcp_line_id: lastHcpLineId,
    principal_diagnosis_code: principalCodes.join(","),
    additional_diagnoses_code: additionalCodes,
    procedure_codes: procedureCodes,
    drg_code: auditValues.auditDrg === "" ? [] : auditValues.auditDrg,
    drg_weight: auditValues.auditNwau === "" ? [] : auditValues.auditNwau,
    is_confirmed: false,
    grouper_versions: [drgAndNwau[0].version],
    request_from: "AU",
    queue_type: "AUDIT",
    queue_id: queueId ?? null,
  };

  acceptCode(payload, location.pathname)
    .then(() => {
      toast.success("Code deleted and updated");
    })
    .catch(() => toast.error("Error updating codes"));
};
useEffect(() => {
  if (currentDrgDetails && currentDrgDetails.length > 0) {
    const data = currentDrgDetails[0];

    setAuditValues({
      auditDrg: data?.drg || "",
      auditNwau: data?.nwau || "",
      auditRevenue: data?.revenue || "",
    });
  }
}, [currentDrgDetails]);

  return (
    <div>
      <div className="auditor-enhance-main">
        <h4>Code Enhance Audit Findings Screen – HCS – Editing</h4>
        <button
          className="editAuditDetails-btn"
          onClick={() => {
            dispatch(fetchDRGInfoOfEpisode());
            dispatch(fetchAuditDrgChanges());
            fetchData1();
            toggleAuditModal();
          }}
          style={{
            border: "none",
            background: "white",
            color: "black",
            marginBottom: "10px",
            marginLeft: "98%",
          }}
        >
          <PencilImg />
        </button>
        <div
          className={`modal fade ${showAuditModal ? "show" : ""}`}
          style={{ display: showAuditModal ? "block" : "none" }}
          tabIndex="-1"
        >
          <div className="modal-dialog" style={{ maxWidth: "50%" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title" style={{ color: "#000000" }}>
                  Audit Results
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  onClick={toggleAuditModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="auditrule-discription-modal">
                  <div style={{ maxHeight: "250px", overflow: "auto" }}>
                    {currentDrgDetails?.map((item, index) => {
                      const auditFields = [
                        {
                          label: "Current DRG",
                          key: "currentDrg",
                          value: item.drg,
                          disabled: true,
                        },
                        {
                          label: "Current NWAU",
                          key: "currentNWAU",
                          value: item.nwau,
                          disabled: true,
                        },
                        {
                          label: "Current Revenue",
                          key: "currentRevenue",
                          value: item.revenue,
                          disabled: true,
                        },
                        {
                          label: "DRG Version",
                          key: "drgVersion",
                          value: item.drg_version,
                          disabled: true,
                        },
                        {
                          label: "Audit DRG",
                          key: "auditDrg",
                          disabled: false,
                        },
                        {
                          label: "Audit NWAU",
                          key: "auditNwau",
                          disabled: false,
                        },
                        {
                          label: "Audit Revenue",
                          key: "auditRevenue",
                          disabled: false,
                        },
                        {
                          label: "Revenue Difference",
                          value: Math.round(
                            item.revenue -
                              Number(auditValues.auditRevenue || 0),
                          ).toFixed(4),
                          disabled: true,
                        },
                      ];

                      return (
                        <div key={index} className="auditenhance-modal-wrapper">
                          {auditFields.map(
                            ({ label, key, value, disabled }) => (
                              <div key={key}>
                                <p>{label}</p>
                                <input
                                  type="text"
                                  value={
                                    disabled ? value : auditValues[key] || ""
                                  }
                                  disabled={disabled}
                                  onChange={(e) => {
                                    if (disabled) return;

                                    const val = e.target.value;

                                    setAuditValues((prev) => {
                                      let updated = { ...prev, [key]: val };

                                      const BASE_RATE = 6465;

                                      // Revenue -> Weight
                                      if (key === "auditRevenue") {
                                        updated.auditNwau = val
                                          ? (Number(val) / BASE_RATE).toFixed(4)
                                          : "";
                                      }

                                      // Weight -> Revenue
                                      if (key === "auditNwau") {
                                        updated.auditRevenue = val
                                          ? Math.round(Number(val) * BASE_RATE)
                                          : "";
                                      }

                                      return updated;
                                    });
                                  }}
                                />
                              </div>
                            ),
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <div
                      style={{
                        borderBottom: "1px solid rgb(222, 226, 230)",
                        fontWeight: "bold",
                        width: "100%",
                        marginTop: "20px",
                      }}
                    >
                      Audit Changes
                    </div>

                    <div className="audit-changes-wrapper">
                      {auditFieldMap.map((field) => {
                        const data = auditDrgChanges[field.key];

                        return (
                          <div
                            key={field.key}
                            className="d-flex align-items-center"
                          >
                            <input
                              type="checkbox"
                              checked={selectedAuditChanges.includes(data?.id)}
                              onChange={(e) =>
                                handleAuditChangeToggle(
                                  data?.id,
                                  e.target.checked,
                                )
                              }
                            />
                            <p>{field.label}</p>

                            {/* ACS Dropdown */}
                            {field.type === "dropdown" && (
                              <Select
                                options={acsOptions}
                                placeholder="Select"
                                isSearchable={false}
                                menuPortalTarget={document.body}
                                // options={acsOptions}
                                value={selectedACSOption}
                                onChange={(selected) =>
                                  setSelectedACSOption(selected)
                                }
                                menuPosition="fixed"
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: "100%",
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "28px",
                                    height: "28px",
                                    marginLeft: "18px",
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    fontSize: "12px",
                                  }),

                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "0 8px",
                                    height: "28px",
                                  }),
                                  option: (base) => ({
                                    ...base,
                                    fontSize: "12px",
                                    padding: "4px 8px",
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    fontSize: "12px",
                                    color: "#888",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "28px",
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            )}
                            {field.type === "text" && (
                              <input
                                type="text"
                                className="other-audit-changes"
                                value={otherComment}
                                onChange={(e) =>
                                  setOtherComment(e.target.value)
                                }
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="coding-changes-wrapper mt-3">
                    <div
                      style={{
                        borderBottom: "1px solid rgb(222, 226, 230)",
                        fontWeight: "bold",
                        width: "100%",
                      }}
                    >
                      Coding changes{" "}
                      <i style={{ fontSize: "12px", fontWeight: "400" }}>
                        Input changes only
                      </i>
                    </div>

                    {isLoading1 ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="coding-changes-wrapper-section">
                        <div className="coding-grid">
                          {/* Header */}
                          <div></div>
                          <div className="header">COF</div>
                          <div className="header">Current Coding</div>
                          <div className="header">COF</div>
                          <div className="header">Audit Coding</div>

                          {/* Principal Diagnosis */}
                          {principal_diagnosis?.map((item, index) => (
                            <React.Fragment key={item.code}>
                              <div className="label">
                                {index === 0 ? "Principal Diagnosis" : ""}
                              </div>

                              <input
                                className="cof"
                                value={extractCodeParts(item.code)?.cof || ""}
                                disabled
                              />
                              <div className="code-with-delete">
                                <input
                                  value={
                                    extractCodeParts(item.code)?.code || ""
                                  }
                                  disabled
                                />

                                <span
                                  className="delete-code-icon"
                                  onClick={() =>
                                    handleDelete("principal", index)
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    className="iconuser-update"
                                    // onClick={() => handleShowDeleteModal(module)}
                                  />
                                </span>
                              </div>
                              <input
                                className="cof"
                                value={
                                  codingState?.principal[index]?.auditCof || ""
                                }
                                onChange={(e) =>
                                  updateAuditField(
                                    "principal",
                                    index,
                                    "auditCof",
                                    e.target.value,
                                  )
                                }
                              />

                              <input
                                type="text"
                                value={
                                  codingState?.principal[index]?.auditCode || ""
                                }
                                className={
                                  hasFieldError("principal", index)
                                    ? "input-error"
                                    : ""
                                }
                                placeholder={
                                  hasFieldError("principal", index)
                                    ? "Invalid Code"
                                    : ""
                                }
                                onBlur={(e) => {
                                  if (e.target.value === "") {
                                    setFieldError("additional", index, false);
                                  }
                                }}
                                onChange={async (e) => {
                                  const value = e.target.value;
                                  updateAuditField(
                                    "principal",
                                    index,
                                    "auditCode",
                                    value,
                                  );

                                  if (value.trim() === "") {
                                    setFieldError("principal", index, false);
                                    return;
                                  }

                                  const result = await validateCodeAPI(
                                    value,
                                    "principal",
                                  );
                                  setFieldError(
                                    "principal",
                                    index,
                                    !result.valid,
                                  );
                                }}
                              />
                            </React.Fragment>
                          ))}

                          {/* Additional Diagnoses */}
                          {(codingState?.additional?.length
                            ? codingState.additional
                            : [{ code: "", auditCode: "", auditCof: "" }]
                          ).map((item, index) => (
                            <React.Fragment key={item.code}>
                              <div className="label">
                                {index === 0 ? "Additional Diagnoses" : ""}
                              </div>

                              <input
                                className="cof"
                                value={extractCodeParts(item.code)?.cof || ""}
                                disabled
                              />
                              <div className="code-with-delete">
                                <input
                                  value={
                                    extractCodeParts(item.code)?.code || ""
                                  }
                                  disabled
                                />

                                <span
                                  className="delete-code-icon"
                                  onClick={() =>
                                    handleDelete("additional", index)
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    className="iconuser-update"
                                    // onClick={() => handleShowDeleteModal(module)}
                                  />
                                </span>
                              </div>

                              <input
                                className="cof"
                                value={item.auditCof || ""}
                                onChange={(e) =>
                                  updateAuditField(
                                    "additional",
                                    index,
                                    "auditCof",
                                    e.target.value,
                                  )
                                }
                              />

                              <input
                                type="text"
                                value={
                                  codingState?.additional[index]?.auditCode ||
                                  ""
                                }
                                className={
                                  hasFieldError("additional", index)
                                    ? "input-error"
                                    : ""
                                }
                                placeholder={
                                  hasFieldError("additional", index)
                                    ? "Invalid Code"
                                    : ""
                                }
                                onBlur={(e) => {
                                  if (e.target.value === "") {
                                    setFieldError("additional", index, false);
                                  }
                                }}
                                onChange={async (e) => {
                                  const value = e.target.value;

                                  // Ensure row exists in state
                                  if (!codingState?.additional[index]) {
                                    setCodingState((prev) => ({
                                      ...prev,
                                      additional: [
                                        ...prev.additional,
                                        {
                                          code: "",
                                          auditCode: "",
                                          auditCof: "",
                                        },
                                      ],
                                    }));
                                  }

                                  updateAuditField(
                                    "additional",
                                    index,
                                    "auditCode",
                                    value,
                                  );

                                  if (value.trim() === "") {
                                    setFieldError("additional", index, false);
                                    return;
                                  }

                                  const result = await validateCodeAPI(
                                    value,
                                    "additional",
                                  );

                                  setFieldError(
                                    "additional",
                                    index,
                                    !result.valid,
                                  );
                                }}
                              />
                            </React.Fragment>
                          ))}

                          {/* Procedure Codes */}
                          {(codingState?.procedure?.length
                            ? codingState.procedure
                            : [{ code: "", auditCode: "" }]
                          ).map((item, index) => (
                            <React.Fragment key={item.code}>
                              <div className="label">
                                {index === 0 ? "Procedure Codes" : ""}
                              </div>

                              <div></div>
                              <div className="code-with-delete">
                                <input value={item.code} disabled />

                                <span
                                  className="delete-code-icon"
                                  onClick={() =>
                                    handleDelete("procedure", index)
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    className="iconuser-update"
                                    // onClick={() => handleShowDeleteModal(module)}
                                  />
                                </span>
                              </div>

                              <div></div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <input
                                  type="text"
                                  value={
                                    codingState?.procedure[index]?.auditCode ||
                                    ""
                                  }
                                  className={
                                    hasFieldError("procedure", index)
                                      ? "input-error"
                                      : ""
                                  }
                                  placeholder={
                                    hasFieldError("procedure", index)
                                      ? "Invalid Code"
                                      : ""
                                  }
                                  onBlur={(e) => {
                                    if (e.target.value === "") {
                                      setFieldError("procedure", index, false);
                                    }
                                  }}
                                  onChange={async (e) => {
                                    const value = e.target.value;

                                    // Ensure row exists in state
                                    if (!codingState?.procedure[index]) {
                                      setCodingState((prev) => ({
                                        ...prev,
                                        procedure: [
                                          ...prev.procedure,
                                          { code: "", auditCode: "" },
                                        ],
                                      }));
                                    }

                                    updateAuditField(
                                      "procedure",
                                      index,
                                      "auditCode",
                                      value,
                                    );

                                    if (value.trim() === "") {
                                      setFieldError("procedure", index, false);
                                      return;
                                    }

                                    const result = await validateCodeAPI(
                                      value,
                                      "procedure",
                                    );

                                    setFieldError(
                                      "procedure",
                                      index,
                                      !result.valid,
                                    );
                                  }}
                                />
                                {inputErrorFiled && (
                                  <span
                                    style={{
                                      fontSize: "10px",
                                      color: "gray",
                                      marginTop: "2px",
                                    }}
                                  >
                                    Please don't enter any ICD codes
                                  </span>
                                )}
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      borderBottom: "1px solid rgb(222, 226, 230)",
                      fontWeight: "bold",
                      width: "100%",
                      marginTop: "20px",
                    }}
                  >
                    Audit Comments
                  </div>
                  <textarea
                    type="text"
                    className="audit-changes-comment"
                    value={auditComment}
                    onChange={(e) => setAuditComment(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleAuditModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleEditSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="audit-details-top-wrapper mb-3">
          {topSectionConfig.length > 0 ? (
            topSectionConfig.map((item, index) => (
              <div key={index}>
                <p className="fw-bold">{item.label}</p>
                <p>{item.value}</p>
              </div>
            ))
          ) : (
            <div style={{ fontSize: "13px" }}>Loading...</div>
          )}
        </div>
        <div className="audit-description-bottom mb-3">
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>Audit Rule/s</p>

          {/* Header */}
          <div
            style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)" }}
          >
            <p className="fw-bold">Audited</p>
            <p className="fw-bold">Priority</p>
            <p className="fw-bold">Short Description</p>
            <p className="fw-bold">Long description</p>
          </div>

          {/* Rows */}
          {topSectionData?.findings.length > 0 ? (
            topSectionData?.findings?.map((item) => (
              <div
                key={item.hcp_audit_id}
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4,1fr)",
                  alignItems: "center",
                }}
              >
                {/* Audited column */}
                <div style={{ display: "flex" }}>
                  <input
                    type="checkbox"
                    checked={item.is_audited}
                    onChange={(e) =>
                      handleAuditToggle(item.hcp_audit_id, e.target.checked)
                    }
                  />
                </div>

                <p>{item.priority}</p>
                <p>{item.short_description}</p>
                <p>{item.long_description}</p>
              </div>
            ))
          ) : (
            <p>No findings</p>
          )}
        </div>
        <div className="comments-text-wrapper-comments">
          <label>Audit Comments:</label>
          <textarea
            value={auditComment}
            onChange={(e) => setAuditComment(e.target.value)}
            placeholder={"Type your comments here..."}
            style={{
              padding: "8px",
              width: "100%",
              height: "100px",
              boxSizing: "border-box",
            }}
          />
          <button className="audit-comment-btn" onClick={handleCommentSubmit}>
            {"Add Comment"}
          </button>
        </div>
        <div className="d-flex gap-3">
          <div className="type-info-wrapper">
            <label>Clinician Query:</label>
            <div className="d-flex flex-column h-100">
              <input
                className="type-info"
                type="text"
                placeholder="Type in info about Clinician Query"
                //  value={inputValue}
                //  onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="comments-text-wrapper">
            <label>Audit Results</label>

            <div className="audit-results-wrapper">
              {bottomAuditConfig.map((item, index) => (
                <div key={index}>
                  <p className="fw-bold mb-3">{item.label}</p>
                  <p>{item.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <button
          className="generate-cdq-btn"
          //  onClick={handleGenerateCDQ}
          //  disabled={iscdqloading || !inputValue.length}
        >
          {"Generate CDQ"}
        </button>
      </div>
    </div>
  );
};

export default AuditorCodeEnhance;
